import { render } from "./wItem.vue?vue&type=template&id=4f241dc5&ts=true"
import script from "./wItem.vue?vue&type=script&lang=ts"
export * from "./wItem.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__